/**
 * Utility function to unhide the Quickshop UI when returned via Section Rendering API.
 *
 * @param {string} string Quickshop section markup
 */
export default function showQuickshop(string) {
  if (!string || !string.length) return;

  const parser = new DOMParser();
  const markup = parser.parseFromString(string, 'text/html');
  const hiddenEl = markup.querySelector('[aria-hidden="true"]');

  hiddenEl.removeAttribute('aria-hidden');
  hiddenEl.classList.remove('hidden');

  return markup.body.innerHTML;
}
